module.exports = __webpack_public_path__ + "img/2.44cf9c01.jpeg";